import tailwindConfig from 'Root/tailwind.config.js';

declare global {
  namespace jest {
    interface Matchers<R> {
      toHaveBeenCalledWithQuery(...expected: unknown[]): R;
      matchGraphQLQuery(expected: string): R;
    }

    interface Expect {
      matchGraphQLQuery(expected: string): unknown;
    }
  }
}

/** Cast partial view/fixture props for specs — TODO(TS-ZERO): tighten */
export function makeViewProps<T>(props: Record<string, unknown>): T {
  return props as unknown as T;
}

/** Minimal AppContext for unit specs — TODO(TS-ZERO): tighten */
export function makeSpecAppContext(partial: Partial<AppContext> = {}): AppContext {
  return partial as AppContext;
}

export type NewsletterItem = {
  id: string;
  description: string;
};

export type NewsletterLegalInformation = {
  id: string;
  description?: string;
  label?: string;
};

export type NewsletterBookingProcessItem = {
  id: string;
  description: string;
  url: string;
  urlLabel: string;
};

export type NewsletterSubscriptionGQLData = {
  config?: CMSContent;
  newsletters?: NewsletterItem[];
  legalInformations?: {
    newsletter?: NewsletterLegalInformation[];
    bookingProcess?: NewsletterBookingProcessItem[];
  };
  subscriptions?: {
    list?: string[];
    email?: string;
  };
};

export type GreatMembersGQLData = {
  animation: Array<import('Components/widgets/event-animation/EventAnimation').AnimationEvent>;
  loyaltyProgram: LoyaltyProgram[];
  loyaltyProgramSimulation: LoyaltyProgramSimulation;
  profile: Profile;
};

export type RelatedEditorialThematicSummary = {
  image: string;
  title: string;
  shortDescription?: string;
  slug: string;
};

export type RelatedEditorialArticleSummary = {
  image: string;
  title: string | null;
  shortDescription?: string;
  slug: string;
  label?: string | null;
  url?: string;
};

export const bucket7TailwindTheme = tailwindConfig.theme as unknown as {
  fontFamily: {
    sans: string;
    brand: string;
  };
  maxWidth: {
    site: string;
  };
};
